import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { ServicoOutputDto } from "src/app/domain/DTOs/output/servicos/servico.output.dto";
import { listarServicos, listarServicosSuccess, listarServicosFailure, listarServicosFinish } from "../../actions/Servicos/servico-jornal.action";

export interface ListarServicosState {
    response: EstruturaRetornoDadosOutputDto<ServicoOutputDto[]> | null;
    error: string[] | null;
}

export const initialState: ListarServicosState = {
    response: null,
    error: null,
};

export const ListarServicosReducer = createReducer(
    initialState,
    on(listarServicos, state => ({ ...state, error: null })),
    on(listarServicosSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(listarServicosFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(listarServicosFinish, state => ({ ...state, response: null, error: null }))
);
